<template>
  <div class="p-3">
    <div class="content-options bg-color14 text-center py-5">
      <header class="mb-15" :class="{ 'flex-start': title }">
        <h2 class="fw-800 text-color10 ls-25 text-uppercase"> {{ title ? title : $t('start_campaign')}} </h2>
        <h3 class="text-center text-uppercase font-size-regular mb-0">{{ subTitle ? subTitle : $t('start_campaign_subtitle') }}</h3>
      </header>

      <div class="main-container mt-md-2 col-lg-12 w-100 text-start mb-5 p-md-10 card">
        <div class="row">

          <div class="col-lg-6">
            <div class="d-block" v-for="category in leftColumnCategories" :key="category">
              <div class="d-block mb-5">
                <h2 class="text-uppercase font-size-regular">{{ campaign_categories['names'][category] }}</h2>
              </div>

              <div class="d-flex m-auto flex-wrap integrations gap-4 gap-lg-2 mb-10" style="place-content: center;">
                <div class="integration-info" v-for="(integration, index) in getIntegrationsByCategory(category)" :key="index" @click="selectIntegration(integration)">
                  <div class="d-flex align-content-center">
                    <div :class="{'selected': selectedIntegration && selectedIntegration.name === integration.name }" class="align-content-center integrations-container bg-color12">
                      <div class="integration-content d-lg-none">
                        <span class="fw-700 text-uppercase font-size-xRegular integration-title d-block text-center"> {{ integration.name }}</span>
                        <div class="integration-content d-flex align-items-center justify-content-center">
                          <img width="45" class="logo" :src="integration.image_url" alt="">
                          <p class="integration-description font-size-xxSmall mb-0 text-uppercase" style="text-align: left;">{{ integration.description }}</p>
                        </div>
                      </div>
                      <div class="integration-content d-none d-lg-block p-3">
                        <div class="d-flex align-items-center justify-content-center">
                          <div class="col-lg-3 text-center">
                            <img width="45" class="logo me-0" :src="integration.image_url" alt="">
                          </div>
                          <div class="col-lg-9">
                            <span class="fw-700 text-uppercase font-size-xRegular integration-title d-block"> {{ integration.name }}</span>
                            <p class="integration-description font-size-xxSmall mb-0 text-uppercase w-100" style="text-align: left;">{{ integration.description }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="d-block" v-for="category in rightColumnCategories" :key="category">
              <div class="d-block mb-5">
                <h2 class="text-uppercase font-size-regular">{{ campaign_categories['names'][category] }}</h2>
              </div>

              <div class="d-flex m-auto flex-wrap integrations gap-4 gap-lg-2 mb-10" style="place-content: center;">
                <div class="integration-info" v-for="(integration, index) in getIntegrationsByCategory(category)" :key="index" @click="selectIntegration(integration)">
                  <div class="d-flex align-content-center">
                    <div :class="{'selected': selectedIntegration && selectedIntegration.name === integration.name }" class="align-content-center integrations-container bg-color12 p-2">
                      <div class="integration-content d-lg-none">
                        <span class="fw-700 text-uppercase font-size-xRegular integration-title d-block text-center"> {{ integration.name }}</span>
                        <div class="integration-content d-flex align-items-center justify-content-center">
                          <img width="45" class="logo" :src="integration.image_url" alt="">
                          <p class="integration-description font-size-xxSmall mb-0 text-uppercase" style="text-align: left;">{{ integration.description }}</p>
                        </div>
                      </div>
                      <div class="integration-content d-none d-lg-block p-3">
                        <div class="d-flex align-items-center justify-content-center">
                          <div class="col-lg-3 text-center me-2">
                            <img width="45" class="logo me-0" :src="integration.image_url" alt="">
                          </div>
                          <div class="col-lg-9">
                            <span class="fw-700 text-uppercase font-size-xRegular integration-title d-block"> {{ integration.name }}</span>
                            <p class="integration-description font-size-xxSmall mb-0 text-uppercase w-100" style="text-align: left;">{{ integration.description }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <!-- end:Integrations listing -->

      <div class="submit-btn col-12 m-auto d-block position-relative">
        <Button
          class="fw-bold text-white btn btn-color10 btn-next"
          @click="submit"
          :disabled="!selectedIntegration"
        >
          {{ $t('next') }}
        </Button>
      </div>
    </div>
  </div>
</template>

<script>

// import IntegrationList from '@/components/integrations/IntegrationList'
import Button from '@/components/common/Button/Button'

export default {
  name: 'NewCreateCampaign',
  components: {
    Button
    // IntegrationList
  },
  props: [
    'title',
    'subTitle'
  ],
  data () {
    return {
      campaign_categories: {
        types: ['recommended', 'news', 'diversification', 'pixel_intelligence'],
        names: {
          recommended: this.$t('recommended'),
          news: this.$t('news'),
          diversification: this.$t('diversification'),
          pixel_intelligence: this.$t('pixel_intelligence')
        }
      },
      integrations: [
        {
          name: 'DV360',
          description: this.$t('dv360_ads_description'),
          type: 'PROGRAMATIC',
          image_url: '/images/pages/campaign/logos/DV360.png',
          purchase_type: ['CPM', 'CPV'],
          format: ['IMAGE', 'VIDEO', 'AUDIO', 'TEXT'],
          minimum_investment: 500, // R$ 500,00
          sales_funnel: ['AWARENESS'],
          route: 'campaigns.programatic.create',
          is_active: true,
          priority: 0,
          category: 'recommended'
        },
        {
          name: 'NATIVE 3.0',
          description: this.$t('native30_ads_description'),
          type: 'NATIVE',
          image_url: '/images/pages/campaign/logos/native30.png',
          purchase_type: ['CPM'],
          format: ['IMAGE', 'TEXT'],
          minimum_investment: 500, // R$ 500
          sales_funnel: ['AWARENESS'],
          route: 'campaigns.native.create',
          is_active: true,
          priority: 1,
          category: 'recommended'
        },
        {
          name: 'SEENTHIS',
          description: this.$t('seenthis_ads_description'),
          image_url: '/images/pages/campaign/logos/seenthis.png',
          purchase_type: ['CPV'],
          format: ['IMAGE', 'TEXT'],
          minimum_investment: 5000, // R$ 5.000,00
          sales_funnel: ['AWARENESS'],
          route: '',
          priority: 3
        },
        {
          name: 'SPOTIFY',
          description: this.$t('spotify_ads_description'),
          image_url: '/images/pages/campaign/logos/spotify.png',
          purchase_type: ['CPM'],
          format: ['IMAGE', 'VIDEO', 'AUDIO'],
          minimum_investment: 5000, // R$ 5.000,00
          sales_funnel: ['AWARENESS'],
          route: 'campaigns.spotify.create',
          priority: 3,
          category: 'diversification'
        },
        {
          name: 'SAMSUNG ADS',
          description: this.$t('samsung_ads_description'),
          image_url: '/images/pages/campaign/logos/samsung-ads.png',
          purchase_type: ['CPV'],
          format: ['VIDEO'],
          minimum_investment: 5000, // R$ 5.000,00
          sales_funnel: ['AWARENESS'],
          route: '',
          priority: 4,
          category: 'diversification'
        },
        {
          name: 'NETFLIX',
          description: this.$t('netflix_ads_description'),
          image_url: '/images/pages/campaign/logos/netflix.png',
          purchase_type: ['CPM'],
          format: ['VIDEO'],
          minimum_investment: 125000, // R$ 125.000,00
          sales_funnel: ['AWARENESS'],
          route: '',
          priority: 5,
          category: 'diversification'
        },
        {
          name: 'NATIVE CONTEXTUAL',
          description: this.$t('mgid_ads_description'),
          image_url: '/images/pages/campaign/logos/mgid.png',
          type: 'NATIVE-CONTEXTUAL',
          purchase_type: ['CPM'],
          format: ['VIDEO', 'IMAGE'],
          minimum_investment: 500, // R$ 500
          sales_funnel: ['AWARENESS'],
          route: 'campaigns.native-contextual.create',
          is_active: true,
          priority: 1,
          category: 'news'
        },
        {
          name: 'NATIVE OPEN',
          description: this.$t('native_open_description'),
          image_url: '/images/pages/campaign/logos/DV360.png',
          type: 'NATIVE-OPEN',
          purchase_type: ['CPM'],
          format: ['VIDEO', 'IMAGE'],
          minimum_investment: 500, // R$ 500
          sales_funnel: ['AWARENESS'],
          route: 'campaigns.native-open.create',
          is_active: true,
          priority: 1,
          category: 'news'
        },
        {
          name: 'UOL ADS',
          description: this.$t('uol_ads_description'),
          image_url: '/images/pages/campaign/logos/uol.png',
          purchase_type: ['CPM'],
          format: ['IMAGE', 'TEXT'],
          minimum_investment: 500, // R$ 500
          sales_funnel: ['AWARENESS'],
          route: 'campaigns.native.create',
          params: {
            platform: 'UOL_ADS'
          },
          priority: 2,
          category: 'news'
        },
        {
          name: 'TABOOLA',
          description: this.$t('taboola_ads_description'),
          image_url: '/images/pages/campaign/logos/taboola.png',
          purchase_type: ['CPM'],
          format: ['IMAGE', 'TEXT'],
          minimum_investment: 500, // R$ 500
          sales_funnel: ['AWARENESS'],
          route: 'campaigns.native.create',
          params: {
            platform: 'TABOOLA'
          },
          priority: 2,
          category: 'news'
        },
        {
          name: 'LINKEDIN',
          description: this.$t('linkedin_ads_description'),
          image_url: '/images/pages/campaign/logos/linkedin.png',
          purchase_type: ['CPM', 'CPC'],
          format: ['TEXT', 'IMAGE'],
          minimum_investment: 5000, // R$ 5000
          sales_funnel: ['CONSIDERATION'],
          route: '',
          priority: 5,
          category: 'pixel_intelligence'
        },
        {
          name: 'INSTAGRAM',
          description: this.$t('instagram_ads_description'),
          image_url: '/images/pages/campaign/logos/instagram.png',
          purchase_type: ['CPM'],
          format: ['IMAGE', 'VIDEO', 'TEXT'],
          minimum_investment: 5000, // R$ 5000
          sales_funnel: ['CONSIDERATION'],
          route: 'campaigns.meta.create',
          priority: 3,
          category: 'pixel_intelligence'
        },
        {
          name: 'FACEBOOK',
          description: this.$t('facebook_ads_description'),
          image_url: '/images/pages/campaign/logos/facebook.png',
          purchase_type: ['CPM'],
          format: ['IMAGE', 'VIDEO', 'TEXT'],
          minimum_investment: 5000, // R$ 5000
          sales_funnel: ['CONSIDERATION'],
          route: 'campaigns.meta-ads.create',
          priority: 3,
          category: 'pixel_intelligence'
        },
        {
          name: 'WHATSAPP',
          description: this.$t('whatsapp_ads_description'),
          image_url: '/images/pages/campaign/logos/whatsapp.png',
          purchase_type: ['CPM', 'CPC'],
          format: ['TEXT', 'IMAGE', 'VIDEO'],
          minimum_investment: 5000, // R$ 5000
          sales_funnel: ['CONSIDERATION'],
          route: '',
          priority: 5,
          category: 'diversification'
        },
        {
          name: 'AMAZON',
          description: this.$t('amazon_ads_description'),
          image_url: '/images/pages/campaign/logos/amazon.png',
          purchase_type: ['COMMISSION'],
          format: ['TEXT', 'IMAGE'],
          minimum_investment: 20000, // R$ 20.000,00
          sales_funnel: ['CONSIDERATION'],
          route: '',
          priority: 2,
          category: 'pixel_intelligence'
        },
        {
          name: 'MELI ADS',
          description: this.$t('meli_ads_description'),
          image_url: '/images/pages/campaign/logos/meli-ads.png',
          purchase_type: ['COMMISSION'],
          format: ['IMAGE', 'TEXT'],
          minimum_investment: 20000, // R$ 20.000,00
          sales_funnel: ['CONSIDERATION'],
          route: '',
          priority: 2,
          category: 'pixel_intelligence'
        },
        {
          name: 'GOOGLE ADS',
          description: this.$t('google_ads_description'),
          type: 'SEARCH',
          image_url: '/images/pages/campaign/logos/google-ads.png',
          purchase_type: ['COMMISSION'],
          format: ['TEXT', 'IMAGE', 'VIDEO'],
          minimum_investment: 5000, // R$ 5.000,00
          sales_funnel: ['CONVERSION'],
          route: 'campaigns.google-ads.create',
          is_active: true,
          priority: 3,
          category: 'pixel_intelligence'
        },
        {
          name: 'YOUTUBE',
          description: this.$t('youtube_ads_description'),
          image_url: '/images/pages/campaign/logos/youtube.png',
          purchase_type: ['CPM', 'CPC', 'COMMISSION'],
          format: ['TEXT', 'IMAGE', 'VIDEO'],
          minimum_investment: 1000, // R$ 1.000,00
          sales_funnel: ['CONVERSION'],
          route: 'campaigns.youtube.create',
          priority: 1,
          category: 'diversification'
        },
        {
          name: 'PUSH',
          description: this.$t('push_ads_description'),
          type: 'PUSH',
          image_url: '/images/pages/campaign/logos/push.png',
          purchase_type: ['CPC'],
          format: ['TEXT', 'IMAGE'],
          minimum_investment: 500, // R$ 500
          sales_funnel: ['CONVERSION'],
          route: 'campaigns.push.create',
          is_active: true,
          priority: 1,
          category: 'news'
        },
        {
          name: 'TIKTOK',
          description: this.$t('tiktok_ads_description'),
          image_url: '/images/pages/campaign/logos/tiktok.png',
          purchase_type: ['COMMISSION'],
          format: ['TEXT', 'IMAGE', 'VIDEO'],
          minimum_investment: 5000, // R$ 5.000,00
          sales_funnel: ['CONVERSION'],
          route: '',
          priority: 5,
          category: 'diversification'
        }
        // {
        //   name: 'ELETROMIDIA',
        //   description: 'ANÚNCIOS EM IMAGEM OU VÍDEO NAS TELAS DE OOH',
        //   image_url: '/images/pages/campaign/logos/eletromidia.png',
        //   purchase_type: ['COMMISSION'],
        //   format: ['TEXT', 'IMAGE', 'VIDEO'],
        //   minimum_investment: 1000, // R$ 1.000,00
        //   sales_funnel: ['CONVERSION']
        // },
        // {
        //   name: 'ADMOOH',
        //   description: 'ANÚNCIOS EM IMAGEM OU VÍDEO NAS TELAS DE OOH',
        //   image_url: '/images/pages/campaign/logos/admooh.png',
        //   purchase_type: ['COMMISSION'],
        //   format: ['TEXT', 'IMAGE', 'VIDEO'],
        //   minimum_investment: 1000, // R$ 1.000,00
        //   sales_funnel: ['CONVERSION']
        // }
      ],
      filters: {
        available_amount: '',
        purchase_type: '',
        format: '',
        sales_funnel: '',
        order_by: ''
      },
      selectedIntegration: ''
    }
  },
  computed: {
    /**
     * Array of active filters
     * @returns {*[]}
     */
    activeFilters () {
      const array = []
      // Go through all filters and create an array of them
      Object.keys(this.filters).forEach(key => {
        if (this.filters[key]) {
          array.push({
            key: key,
            value: this.filters[key]
          })
        }
      })
      return array
    },
    /**
     * Array of filtered integration items
     * @returns {*}
     */
    filteredIntegrations () {
      // Filter array
      const array = JSON.parse(JSON.stringify(this.integrations)).filter(item => {
        // Apply format filter
        if (this.filters.format && !item.format.includes(this.filters.format)) return false
        // Apply purchase type filter
        if (this.filters.purchase_type && !item.purchase_type.includes(this.filters.purchase_type)) return false
        // Apply funnel filter
        if (this.filters.sales_funnel && !item.sales_funnel.includes(this.filters.sales_funnel)) return false
        // Apply amount filter
        if (this.filters.available_amount && parseInt(this.filters.available_amount) < parseInt(item.minimum_investment)) return false
        return true
      })
      // Sort array
      array.sort((a, b) => {
        if (!this.filters.order_by) return 0
        if (this.filters.order_by === 'USAGE') return a.priority - b.priority
        if (this.filters.order_by === 'AMOUNT') return b.minimum_investment - a.minimum_investment
      })
      return array
    },
    /**
     * Get first half of integrations
     */
    leftColumnCategories () {
      const types = this.campaign_categories.types
      const midpoint = Math.ceil(types.length / 2)
      return types.slice(0, midpoint)
    },

    /**
     * Gets second half of integrations
     */
    rightColumnCategories () {
      const types = this.campaign_categories.types
      const midpoint = Math.ceil(types.length / 2)
      return types.slice(midpoint)
    }
  },
  methods: {
    getIntegrationsByCategory (category) {
      return this.filteredIntegrations.filter(integration => integration.category === category)
    },
    /**
     * Remove filter
     * @param filter
     */
    removeFilter (filter) {
      this.filters[filter.key] = ''
    },
    /**
     * Handle select integration
     * @param integration
     */
    selectIntegration (integration) {
      this.selectedIntegration = integration
      const element = document.querySelector('.btn-next')
      const yOffset = -10 // Adjust as needed
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset
      window.scrollTo({ top: y, behavior: 'smooth' })
    },
    /**
     * Submit
     */
    submit () {
      if (!this.selectedIntegration.route) return this.$router.push({ name: 'campaigns.request', query: { type: this.selectedIntegration.name } })
      this.$router.push({ name: this.selectedIntegration.route, query: { integrationInfo: this.selectedIntegration } })
    }
  }
}
</script>

<style lang="scss" scoped>
.submit-btn {
  text-align: right;
}

.main-container {
  place-items:center;
}

@media (min-width: 320px) and (max-width: 767px) {
  .card {
    background-color: unset;
    box-shadow: unset;
    border: unset;
  }
}

.filters-container, .ordering-container  {
  button, select {
    border: none;
  }
  select {
    padding: 10px;
  }
}

.ordering-container {

  .styled-order-input {
    label {
      cursor: pointer;
      background: $color12;
      font-weight: bold;
      text-transform: uppercase;
      padding: 5px 10px;

      &.checked {
        color: #fff;
        background: $color10;
      }

      div {
        font-size: $font_size_small;
      }
    }
    input {
      display: none;
    }
  }
}

.active-filters {
  button {
    font-size: $font-size_small;
    padding: 5px 8px;
  }
}

h2 {
  font-size: 35px;

  @media (min-width: 376px) {
    font-size: 40px;
  }

  @include desktop {
    font-size: 48px;
  }
}

.content-objective {
  background-color: #e8e8e8;
  right: 0;
  padding: 1rem;

  @include tablet {
    padding: 2rem;
  }
}

.filters-container, .ordering-container  {
  button, select, option {
    border: none;
  }

  .filters {
    text-align: left;
    text-align-last: center;
    place-content: space-between;
  }

  .sorting {
    text-align: left;
    padding: 0 10px;
    text-align-last: center;
    place-content: space-between;
  }

  .order-selected {
    background-color: #d9ab46;
    -webkit-transition: background-color 100ms linear;
    -ms-transition: background-color 100ms linear;
    transition: background-color 100ms linear;
  }
}

.active-filters {
  text-align: left;
  padding: 0 10px;
}

.integrations-container {
  height: 95px;
  width: 250px;
  -webkit-filter: grayscale(100%) !important;
  filter: grayscale(100%) !important;
  transition: filter 0.5s ease-in-out;
  border: 3px solid transparent;
  cursor: pointer;

  @include desktop {
    width: 230px;
  }

  @include desktop-xl {
    width: 270px;
  }

  &:hover {
    -webkit-filter: grayscale(0%) !important;
    filter: grayscale(0%) !important;
  }

  &.selected {
    animation: 0.8s ease-in-out;
    border-color: #d9ab46;
    filter: grayscale(0%) !important;
  }

  .integration-title {
    overflow-wrap: break-word;
  }

  .coming-soon {
    position: absolute;
    top: -17px;
    padding: 0 4px
  }

  .logo-container {
    img {
      width: 45px !important;
    }
  }
}

.integration-info {
  display: block;
  padding: 0.2rem;
  font-size: 1rem;
  text-align: left;
}

.disabled {
  pointer-events: none;
}

.flex-basis {
  flex-basis: 100%;
}

.close-btn {
  cursor: pointer;
}

@media only screen and (max-width: 1240px) {
  .integration-title {
    overflow-wrap: break-word;
  }
}

.integration-info {
  .logo {
    margin-right: 10px;
  }
  .integration-content {
    .integration-description {
      width: 60%;
    }
  }
}
</style>
